<script lang="ts" setup>
    import { computed, useAttrs, useSlots } from "vue";
    import SearchIcon from "@icons/search.svg";
    import WhitePlusIcon from "@icons/white-plus.svg";
    import CarretsBlackIcon from "@icons/carrets-black.svg";
    import RedArrowsIcon from "@icons/red-arrows.svg";

    import { Link } from "@inertiajs/vue3";

    let $attrs = useAttrs();
    const props = defineProps({
        ctaType: {
            type: String,
            default: "button"
        },
        button_icon: {
            type: String,
            default: "carret"
        },
        inertia: {
            type: Boolean,
            default: true
        },
        external: {
            type: Boolean,
            default: false
        },
        htmlSlotted: {
            type: Boolean,
            default: false
        },
        preserveState: {
            type: Boolean,
            default: false
        },
        preserveScroll: {
            type: Boolean,
            default: false
        },
        onSuccess: {
            type: Function,
            default: () => {}
        }
    });

    let elementTypeComputed = computed(() => {
        switch (props.ctaType) {
            case "button":
                return "button";
            case "link":
            case "a":
                return "a";
            case "div":
                return "div";
            default:
                return "button";
        }
    });

    const slots = useSlots();
    const hasSlotContent = computed(()=>{
        if(props.htmlSlotted){
            return true;
        }
        return !!(slots?.default?.()[0]?.children?.trim());
    })
    function toExternal(event) {
        if (props.external) {
            event.preventDefault();
            window.open($attrs.href, "_blank");
        }
    }
</script>
<template>
    <component :preserve-state="preserveState" :preserve-scroll="preserveScroll"  v-if="hasSlotContent" :is="$attrs?.href && !external ? Link : elementTypeComputed" :as="elementTypeComputed" id="rothco_cta" @click="toExternal" :aria-label="$attrs['aria-label']" :onSuccess="onSuccess" v-bind="$attrs" v-on="$attrs">
        <slot></slot>
        <span v-if="elementTypeComputed === 'button' && props.button_icon" aria-label="hidden" class="icon">
            <SearchIcon
                id="search"
                v-if="button_icon === 'search'"
                alt="search-icon"
            />
            <WhitePlusIcon
                id="plus"
                v-if="button_icon === 'plus'"
                alt="plus-icon"
            />
            <CarretsBlackIcon
                id="carret"
                v-else-if="button_icon === 'carret'"
                alt="carret right"
            />
            <RedArrowsIcon
                id="red-arrows"
                v-else-if="button_icon === 'red-arrows'"
                src="@icons/red-arrows.svg"
                alt="red arrow"
            />
        </span>
    </component>
</template>
